import Vue from "vue";
import App from "./App";
import router from "./router/index";
import { BootstrapVue } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { ClientTable } from 'vue-tables-2';
import PaperDashboard from "./plugins/paperDashboard";
import VueLoading from 'vuejs-loading-plugin';
import Vuelidate from 'vuelidate';
import store from './store';
import 'regenerator-runtime/runtime';

Vue.use(Vuelidate);
Vue.use(PaperDashboard);
Vue.use(ClientTable);
Vue.use(BootstrapVue)

Vue.use(VueLoading, {
  dark: true,
  text: 'Cargando ...',
  loading: false
  // background: 'rgb(255,255,255)'
})

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
